module.exports = __webpack_public_path__ + "static/media/kefu.33581c93.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/kefu.png
// module id = 1792
// module chunks = 0 1